<template>
  <div>
    <div
      v-if="needProfiles.length>0"
      class="my-3 text-danger lead"
    >
      {{ $t('changeAccountPopup.buMliyyatIcraEdBilmkNNeedprofilenamesProfilinizAkt',{name:needProfileNames}) }}
    </div>


    <div class="card">
      <div
        v-for="c in companyList"
        :key="c.id"
        class="card-body"
      >
        <div
          class="row pointer"
          @click="companyClicked(c.id)"
        >
          <div class="col-4 col-md-3 col-lg-2">
            <img
              :src="getPhoto(c.logo,'thumbnailCropped')"
              :alt="`${c.name}`"
              class="img-thumbnail img-fluid rounded-circle"
            >
          </div>
          <div class="col-8 col-md-9 col-lg-10">
            <div>
              <h5 class="font-weight-bold">
                {{ c.name }} {{ getCompanyFormat(c.format) }}
              </h5>
              <span>{{ c.taxId }}</span>
            </div>
          </div>
        </div>

        <div
          v-if="selectedCompanyId===c.id"
          class=" list-group list-group-flush mt-3"
          style="margin-left: 50px;"
        >
          <div
            v-for="p in companyProfiles(c.id)"
            :key="p.id"
            class="list-group-item list-group-item-action"
            style="cursor: pointer;"
            @click.prevent="changeAccount(c.id, p.profileType, 'company')"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <img
                  :src="getProfileIcon(p.profileType)"
                  alt=""
                  class="mr-3"
                  style="height: 30px; width: 30px;"
                >
                <div>
                  <span class="font-weight-bold">{{ p.position }}</span> <br>
                  <span class="small text-secondary">{{ getProfileName(p.profileType) }}</span>
                </div>
              </div>
              <feather type="chevron-right" />
            </div>
          </div>

          <router-link
            v-if="
              ( needProfiles.length===0 && companyProfiles(c.id).length<4 ) ||
                ( needProfiles.length>0 && companyProfiles(c.id).length<needProfiles.length )"
            class="list-group-item list-group-item-secondary pointer"
            :to="{name: `companyPage`, params:{id: c.id}}"
          >
            <div class="d-flex justify-content-between">
              <div>
                <span class="font-weight-bold">{{ $t('changeAccountPopup.yeniProfilYarat') }}</span>
              </div>
              <feather type="plus" />
            </div>
          </router-link>
        </div>
      </div>
    </div>


    <div
      class="card cursor-enabled"
      @click.prevent="$router.push({name: 'companySearch'})"
    >
      <div class="card-body d-flex align-items-center">
        <feather
          type="plus"
          class="mr-3"
        />
        <strong> {{ $t('changeAccountPopup.yeniIrktLavEt') }}</strong>
      </div>
    </div>

    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {userAccounts, userSetAccount} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileIcon, getProfileName} from "@/repositories/Utils";


export default {
  components: {},
  props: {
    needProfiles: {
      type: Array,
      default() {
        return [];
      }
    },
    company: {
      type: Object,
      default() {
        return null;
      }
    },
  },
  data() {
    return {
      mediaBase: mediaBase,
      profiles: [],
      selectedCompanyId: null,
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


    needProfileNames() {
      return this.needProfiles.map(p => getProfileName(p)).join(", ");
    },

    companyList() {

      let idList = [];
      let list = [];

      this.profiles.forEach(p => {
        if (idList.indexOf(p.company.id) === -1) {
          idList.push(p.company.id);
          list.push(p.company);
        }
      })

      return list;

    },

  },
  watch: {
    token(newValue) {
      userAccounts(newValue).then(data => {
        this.profiles = data;
      });
    }
  },
  mounted() {

    if (this.company) {
      this.selectedCompanyId = this.company.id;
    }

    userAccounts(this.token).then(data => {
      this.profiles = data;
    });
  },
  methods: {

    companyProfiles(companyId) {
      let list = [];
      this.profiles.forEach(p => {
        if (p.company.id === companyId && (this.needProfiles.length === 0 || this.needProfiles.indexOf(p.profileType) > -1)) {
          list.push(p);
        }
      })
      return list;
    },

    companyClicked(id) {
      this.selectedCompanyId = this.selectedCompanyId === id ? null : id;
    },

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    }, getProfileIcon(keyword) {
      return getProfileIcon(keyword);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    changeAccount(companyId, profileType, accountType) {
      userSetAccount(this.token, companyId, profileType, accountType).then(data => {

        if (data.code === 200) {
          window.location.reload();
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
          })
        }

      })
    },

  }

}
</script>
<style>
.cursor-enabled {
  cursor: pointer;
}
</style>
